/**
 * Utility functions for accessing saved map visualization variables
 */

import { visualizationOptions as defaultVisualizationOptions } from '../components/map/mapConfig';

const STORAGE_KEY_HEAT = 'mapVisualizationOptions_heat';
const STORAGE_KEY_DOT = 'mapVisualizationOptions_dot';

/**
 * Get heat map visualization variables from localStorage, falling back to defaults
 * @returns {Array} Array of visualization options {value, label, category}
 */
export const getHeatMapVariables = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY_HEAT);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed;
      }
    }
  } catch (e) {
    console.warn('Failed to load heat map variables:', e);
  }
  return [...defaultVisualizationOptions];
};

/**
 * Get dot density visualization variables from localStorage, falling back to defaults
 * @returns {Array} Array of visualization options {value, label, category}
 */
export const getDotDensityVariables = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY_DOT);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed;
      }
    }
  } catch (e) {
    console.warn('Failed to load dot density variables:', e);
  }
  return [...defaultVisualizationOptions];
};

/**
 * Get all unique visualization variables (combined from both heat and dot)
 * @returns {Array} Array of unique visualization options
 */
export const getAllVisualizationVariables = () => {
  const heat = getHeatMapVariables();
  const dot = getDotDensityVariables();

  // Combine and deduplicate by value
  const combined = new Map();
  [...heat, ...dot].forEach(opt => {
    if (!combined.has(opt.value)) {
      combined.set(opt.value, opt);
    }
  });

  return Array.from(combined.values());
};

/**
 * Save heat map variables to localStorage
 * @param {Array} options - Array of visualization options
 */
export const saveHeatMapVariables = (options) => {
  localStorage.setItem(STORAGE_KEY_HEAT, JSON.stringify(options));
};

/**
 * Save dot density variables to localStorage
 * @param {Array} options - Array of visualization options
 */
export const saveDotDensityVariables = (options) => {
  localStorage.setItem(STORAGE_KEY_DOT, JSON.stringify(options));
};
